import { Interjection } from '../../types'

const блять: Interjection = {
  type: 'interjection',
  interjection: 'блять',
}

export default блять
